import React, { PureComponent } from 'react';
import RenglonDatosAdicionales from './RenglonDatosAdicionales';
import BuscadorCuentasContables from '../../Common/BuscadorCuentasContables';
class RegistroRenglonAsiento extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            debeActivo: true,
            haberActivo: true, 
            inputBuscadorCuentaContable:"",
        };
        this.handleInputImporteChange = this.handleInputImporteChange.bind(this);
        this.handleMonedaChange = this.handleMonedaChange.bind(this);
    }

    handleInputImporteChange = (event) => {
        const { registro, onImporteChange, monedasAsiento} = this.props;
        let { value } = event.target;
        let fieldName = event.target.name;
        let parsedValue = value.replace(/[^\d,]/g, '');
        let tipoOperacion = fieldName === 'inputImporteDebe' ? 1 : 2;
        let codigoMoneda = registro && registro.MonedaSalidaCodigo || registro && registro.ModeloMonedaSalidaCodigo;
        let monedaSeleccionada = monedasAsiento.find(moneda => moneda.Codigo == codigoMoneda)

        const parts = parsedValue.split(',');
        if (parts.length > 2 || (parts.length === 2 && parts[1].length > 2)) {
            return;
        }
        // Validar que los dígitos enteros no excedan nueve
        if (parts[0].length > 9) {
            return;
        }
        // No permitir que el valor comience con cero a menos que sea "0,"
        if (parts[0].length > 1 && parts[0][0] === '0') {
            return '';
        }
        if (parts[0] === '0' && parts.length === 1) {
            return '';
        }
    
  
        onImporteChange(this.props.registro.renglonId, parsedValue, monedaSeleccionada.Codigo, monedaSeleccionada.Id, tipoOperacion);
    
        if (fieldName === 'inputImporteDebe' && Boolean(parsedValue)) {
            this.setState({ debeActivo: true, haberActivo: false });
        } else if (fieldName === 'inputImporteHaber' && Boolean(parsedValue)) {
            this.setState({ debeActivo: false, haberActivo: true });
        } else if (!Boolean(parsedValue)) {
            this.setState({ debeActivo: true, haberActivo: true });
        } else {
            this.setState({ debeActivo: true, haberActivo: true });
        }
    };
          
    handleMonedaChange = (event) => {
        const {registro, cuentasContables, onCuentaContableChange, onValorReferenciaChange, onImporteChange, OnMonedaSeleccionadaChange, monedasAsiento}  = this.props;

        let monedaSeleccionada = monedasAsiento.find(moneda => moneda.Id == event.target.value)

        let tipoOperacion = this.state.debeActivo ? 1 : 2;

        let cuentaContableValida = cuentasContables.find( cuenta => (cuenta.Codigo + " - " + cuenta.Descripcion) === registro.CuentaContableDescripcion && (cuenta.MonedaId === 0 || cuenta.MonedaId == nuevaMoneda));
    
        if (!cuentaContableValida) {
            onCuentaContableChange(registro.renglonId, "", "");
            onValorReferenciaChange(registro.renglonId, "")
            onImporteChange(registro.renglonId, "", monedaSeleccionada.Id, tipoOperacion);
            this.buscarCuentasContables("");
            this.setState({ inputBuscadorCuentaContable: "" });
        }

        onImporteChange(registro.renglonId, "", monedaSeleccionada.Id, tipoOperacion);

        OnMonedaSeleccionadaChange(registro.renglonId, monedaSeleccionada.Codigo, monedaSeleccionada.Id)

        this.setState({
            debeActivo: true,
            haberActivo: true
         });
    }
    
    handleGuardarValorInput = (cuentaId, codigo, descripcionCuenta) => {
        const { registro, onCuentaContableChange } = this.props;
        onCuentaContableChange(registro.renglonId, cuentaId, codigo, descripcionCuenta );
    };

    handleInputBuscadorChange = (descripcionCuenta) => {
        this.setState({ inputBuscadorCuentaContable: descripcionCuenta });
    };

    buscarCuentasContables = (valorInput) => {
        this.props.buscarCuentasContables(this.props.registro.renglonId,"modalAsientosContables", valorInput )
    };

    componentDidMount(){
        const { registro } = this.props;

        // en caso de que el registro a instanciar (que corresponde a un renglon contable) posea un Id de cuenta contable y un importe cargado, se ajusta la interactividad 
        // para que esos datos se vean correctamente y con los inputs de importe activados o no, segun sea su tipo de operacion y si tiene una cuenta previamente seleccionada

        if(registro && registro.CuentaContableId){
            this.setState({ inputBuscadorCuentaContable : registro.CuentaContableDescripcion });
        }

        if (registro && !!registro.ImporteAsiento) {
            const isDebeActivo = registro.TipoOperacion === 1;
            this.setState({
                debeActivo: isDebeActivo,
                haberActivo: !isDebeActivo
            });
        }
        
        $('[data-toggle="tooltip"]').tooltip();
    };

    componentDidUpdate() {
        $('[data-toggle="tooltip"]').tooltip();
    };

    render() {
        const { registro,
                registroAsientoContable,
                renglonesAgregadosManualmente,
                detalleRenglonDatosDesplegados,
                desplegarDatosDetalleRenglon, 
                totalDebe, 
                totalHaber,
                tipoMoneda,
                esSeparador,
                esTotalizador,
                cuentasContables,
                inputActivo, 
                centrosCosto, 
                onRenglonEliminado, 
                onValorReferenciaChange,
                descargaTipoMovimiento,
                onCentroCostoChange,
                OnInputValorReferencia,
                cambiarInputActivo,
                tienePermisoModificacion,
                monedasAsiento } = this.props;


        if (esTotalizador && registro == null && totalDebe == 0 && totalHaber == 0) {
            return null; 
        }

        let hayCuentaSeleccionada = cuentasContables && cuentasContables.some(cuenta => cuenta.Codigo + " - " + cuenta.Descripcion == this.state.inputBuscadorCuentaContable);
        let activaInputBuscador = !!(registro && (inputActivo === registro.renglonId));

        let cuentasFiltradasPorMoneda = registro && registro.cuentasContablesFiltradas && registro.cuentasContablesFiltradas.filter(cuenta =>
            cuenta.MonedaId == 0 || cuenta.MonedaId == registro.ModeloMonedaSalidaId
          );

        let habilitarInputRenglon = registro && registro.RenglonAgregadoManualmente;
        let habilitarComboboxCuentaContable = registro && registro.RenglonAgregadoManualmente;

        let habilitaMonedaDebe = registro && registro.TipoRenglon === 2 && !registro.ImporteAsiento && registro.TipoOperacion == 1 || registro && registro.RenglonManual && registro.TipoOperacion == 1 || registro && registro.RenglonAgregadoManualmente && this.state.debeActivo

        let habilitaMonedaHaber = registro && registro.TipoRenglon === 2 && !registro.ImporteAsiento && registro.TipoOperacion == 2 || registro && registro.RenglonManual && registro.TipoOperacion == 2 || registro && registro.RenglonAgregadoManualmente && this.state.haberActivo

        let estaDesplegado = registro && (detalleRenglonDatosDesplegados == registro.renglonId);
        
        let estiloFlechaDesplegado = estaDesplegado ? "seccionRenglonesModelo__renglonModelo__trianguloUp" : "seccionRenglonesModelo__renglonModelo__trianguloDown";
        
        let estiloRenglonBalance = registro && registro.TipoRenglon == 3 && registro.ImporteAsiento && !registro.RenglonManual ? " AsientosContables__modalDetalleAsiento__registroGrillaBalance" : "";
        let estiloContenedorCuentasContablesHaberActivo = registro && registro.RenglonAgregadoManualmente && registro.TipoOperacion == 2 && this.state.haberActivo ? " AsientosContables__marginContenedorBuscadorHaberActivo" : ""

        let estiloTotales = registro == null ? "AsientosContables__modalDetalleAsiento__registroGrillaTotales" : "";

        let estiloCursiva = registro && registro.TipoRenglon == 2 ? " letra-cursiva-grilla-renglones" : "";

        estiloCursiva = registro && !registro.ImporteAsiento && registro.TipoRenglon == 2 && !registro.RenglonAgregadoManualmente || registro && registro.RenglonManual && !registro.ImporteAsiento && !registro.RenglonAgregadoManualmente ? " letra-cursiva-grilla-renglones-gris" : estiloCursiva;

        let estiloIdentacionHaber = registro && registro.TipoOperacion == 2 && !!registro.ImporteAsiento || registro && registro.TipoOperacion == 2 && registro.RenglonManual ? " AsientosContables__modalNuevoAsiento__registroGrillaRenglon--haber" : "";

        let estiloLetraAgregada = registro && registro.RenglonAgregadoManualmente ? "AsientosContables__paddingLetraHaberRenglonAgregadoManual" : ""
        let letraAgregadaRenglonTipoHaber = registro && registro.RenglonAgregadoManualmente && !!registro.ImporteAsiento && registro.TipoOperacion == 2 && this.state.haberActivo ? <div className={estiloLetraAgregada} >a)</div> : "" 

        let totalDebeValor = totalDebe !== undefined ? totalDebe : (registro && registro.TipoOperacion == 1 ? registro.ImporteAsiento : null);
        let totalHaberValor = totalHaber !== undefined ? totalHaber : (registro && registro.TipoOperacion !== 1 ? registro.ImporteAsiento : null);

        if (totalDebeValor){
            totalDebeValor = totalDebeValor.toLocaleString('es-AR', {minimumFractionDigits: 2}) 
        } 

        if (totalHaberValor){
            totalHaberValor = totalHaberValor.toLocaleString('es-AR', {minimumFractionDigits: 2}) 
        } 

        let asientoContableDescripcion = registro && registro.DescripcionRenglon ? (registro.DescripcionRenglon.length > 32 ? registro.DescripcionRenglon.substring(0, 32) + '...' : registro.DescripcionRenglon) : '';
        let cuentaContableDescripcion = registro && registro.CuentaContableDescripcion ? (registro.CuentaContableDescripcion.length > 32 ? registro.CuentaContableDescripcion.substring(0, 32) + '...' : registro.CuentaContableDescripcion) : '';
        
        let simboloMoneda = registro && registro.RenglonManual && registro.MonedaSalidaCodigo ? registro.MonedaSalidaCodigo : tipoMoneda
            simboloMoneda = registro && registro.ModeloMonedaSalidaCodigo ? registro.ModeloMonedaSalidaCodigo : simboloMoneda;
            simboloMoneda = registro && registro.RenglonAgregadoManualmente ? null : simboloMoneda

        switch (simboloMoneda) {
            case "PESO":
                simboloMoneda = "$";
                break;

            case "DOLAR":
                simboloMoneda = "U$S";
                break;

            default:
                simboloMoneda = null;
                break;
        }

          let monedasCombo = monedasAsiento ? monedasAsiento.filter(moneda => moneda.Codigo == "PESO" || moneda.Codigo == "DOLAR") 
                                                                .map(moneda => (
                                                                    <option key={moneda.Codigo} value={moneda.Id}>
                                                                    {moneda.Codigo == "PESO" ? "$" : "U$S"}
                                                                    </option>
                                                                )) : [];
          

        return (
            esSeparador ?
            <hr className="linea-divisoria-grilla-renglones" /> :
            <div className="AsientosContables__modalDetalleAsiento__contenedorRegistroGrilla--width">
                <div className="AsientosContables__modalDetalleAsiento__contenedorRegistroGrilla">
                    <div className={"seccionRenglonesModelo__renglonModelo__contenedorRegistros AsientosContables__modalDetalleAsiento__registroGrillaRenglon AsientosContables--noPadding" + estiloRenglonBalance + estiloCursiva}>
                        {registro && habilitarInputRenglon ? (
                            <input
                            type="text"
                            className="AsientosContables__modalDetalleAsiento__registroGrillaInput"
                            value={registro && registro.DescripcionRenglon ? registro.DescripcionRenglon : ""}
                            onChange={(event) => this.props.onDescripcionChange(registro.renglonId, event.target.value)}
                          />
                        ) : (
                            <span {...registro && registro.DescripcionRenglon && registro.DescripcionRenglon.length > 32 && { "data-toggle": "tooltip", title: registro.DescripcionRenglon }}>
                            {registro ? asientoContableDescripcion : ''}
                        </span>
                        )}
                    </div>
                    <div className={"seccionRenglonesModelo__renglonModelo__contenedorRegistros AsientosContables__modalDetalleAsiento__registroGrillaCuentaContable AsientosContables__modalDetalleAsiento__registroGrillaCuentaContable--widthDetalleRenglon AsientosContables--noPadding" + estiloRenglonBalance + estiloIdentacionHaber + estiloCursiva + estiloContenedorCuentasContablesHaberActivo}>
                         {letraAgregadaRenglonTipoHaber}
                        {registro && habilitarComboboxCuentaContable ? ( 
                            <div className="AsientosContables_ModalDetalleAsiento_ContenedorBuscadorCuentasContables">
                            <BuscadorCuentasContables 
                                buscarCuentasContables={this.buscarCuentasContables}
                                cuentasContables={cuentasFiltradasPorMoneda}
                                cambiarValorInput={this.handleInputBuscadorChange}
                                cambiarInputActivo={cambiarInputActivo}
                                nroRenglon={registro.renglonId}
                                estaHabilitado={true}
                                valorInput={this.state.inputBuscadorCuentaContable}
                                guardarValorInput={this.handleGuardarValorInput}
                                onValorReferenciaChange={onValorReferenciaChange}
                                esHaber={!!totalHaberValor}
                                inputActivo={activaInputBuscador}
                                nombreInput={"inputCuentaContable"}
                                seccionInput={"modalAsientosContables"}
                                inputClassValorSeleccionado={hayCuentaSeleccionada ? " AsientosContables__buscadorCuentasContables--valorSeleccionado" : ""}
                                contenedorInputBuscador={"AsientosContables_ModalDetalleAsiento_BuscadorCuentasContables--width"}
                            />
                            </div>
                            ) : (
                            <span {...registro && registro.CuentaContableDescripcion && registro.CuentaContableDescripcion.length > 32 && { "data-toggle": "tooltip", title: registro.CuentaContableDescripcion }}>
                                {registro && registro.TipoOperacion === 2 ? "a) " : ""}
                                {registro && registro.CuentaContableCodigo + ' - ' + cuentaContableDescripcion}
                            </span>
                        )}
                    </div>
                  
                    <div className={"seccionRenglonesModelo__renglonModelo__contenedorRegistros AsientosContables__modalDetalleAsiento__registroGrillaDebe AsientosContables--noPadding" + estiloTotales + estiloRenglonBalance + estiloCursiva}>
                        {habilitaMonedaDebe ? (
                            <div>
                             {simboloMoneda}
                             {registro && registro.RenglonAgregadoManualmente && this.state.debeActivo? (
                                  <select 
                                  name="comboMoneda" 
                                  className="seccionDatosGenerales__inputSelect seccionDatosGenerales__sucursalSelect AsientosContables--noMargin AsientosContables--combo-seleccion-moneda-grilla" 
                                  value={registro && registro.ModeloMonedaSalidaId} 
                                  onChange={this.handleMonedaChange}>
                                       {monedasCombo}
                                </select>
                                         ): null}
                             <input
                                    type="text"
                                    className="seccionDatosGenerales__inputSelect AsientosContables__filtrosAdicionalesIdAsientoMoneda AsientosContables__inputImporteGrilla"
                                    name="inputImporteDebe"
                                    id="inputImporteDebe"
                                    value={registro.ImporteAsiento ? registro.ImporteAsiento.replace(".", ",") : null}
                                    onChange={this.handleInputImporteChange}
                                />
                            </div>
                        ) : registro && !registro.RenglonAgregadoManualmente && totalDebeValor && simboloMoneda ? simboloMoneda : null}               
                           {registro && !registro.RenglonAgregadoManualmente && !registro.RenglonManual && totalDebeValor ? totalDebeValor : null} 
                           {esTotalizador && totalDebeValor && simboloMoneda ? simboloMoneda : null}
                           {esTotalizador  && totalDebeValor ? totalDebeValor : null}
                    </div>
        
                    <div className={"seccionRenglonesModelo__renglonModelo__contenedorRegistros AsientosContables__modalDetalleAsiento__registroGrillaHaber AsientosContables--noPadding" + estiloTotales + estiloRenglonBalance + estiloCursiva}>
                    {habilitaMonedaHaber ? (
                            <div>
                             {simboloMoneda}
                             {registro && registro.RenglonAgregadoManualmente && this.state.haberActivo ? (
                                  <select 
                                  name="comboMoneda" 
                                  className="seccionDatosGenerales__inputSelect seccionDatosGenerales__sucursalSelect AsientosContables--noMargin AsientosContables--combo-seleccion-moneda-grilla" 
                                  value={registro && registro.ModeloMonedaSalidaId} 
                                  onChange={this.handleMonedaChange}>
                                         {monedasCombo}
                                </select>
                                         ): null}
                                <input
                                    type="text"
                                    className="seccionDatosGenerales__inputSelect AsientosContables__filtrosAdicionalesIdAsientoMoneda AsientosContables__inputImporteGrilla"
                                    name="inputImporteHaber"
                                    id="inputImporteHaber"
                                    value={registro.ImporteAsiento ? registro.ImporteAsiento.replace(".", ",") : null}
                                    onChange={this.handleInputImporteChange}
                                />              
                            </div>
                        ) :
                        registro && !registro.RenglonAgregadoManualmente && totalHaberValor && simboloMoneda ? simboloMoneda : null} 
                        {registro && !registro.RenglonAgregadoManualmente && !registro.RenglonManual && totalHaberValor ? totalHaberValor : null}
                        {esTotalizador && totalHaberValor && simboloMoneda ? simboloMoneda : null}
                        {esTotalizador  && totalHaberValor ? totalHaberValor : null}
                    </div>
                   
                    {registro && !esTotalizador ?  <div className={"seccionRenglonesModelo__renglonModelo__contenedorRegistros AsientosContables__modalDetalleAsiento__registroGrillaBotonDesplegable AsientosContables--noPadding" + (!registro && totalDebeValor ? " AsientosContables__modalDetalleAsiento__registroGrillaTotalesCeldaBotonDesplegable" : "") + estiloRenglonBalance}>
        
                     <div className={"AsientosContables__modalDetalleAsiento__botonDesplegableGrilla " + estiloFlechaDesplegado} onClick={() => desplegarDatosDetalleRenglon(registro)}></div>
                       
                    </div>
                         :
                         null
                     }
                </div>
        
                <RenglonDatosAdicionales
                    registro={registro}
                    registroAsientoContable={registroAsientoContable}
                    cuentasContables={cuentasContables}
                    descargaTipoMovimiento={descargaTipoMovimiento}
                    onRenglonEliminado={onRenglonEliminado}
                    onValorReferenciaChange={onValorReferenciaChange}
                    onCentroCostoChange={onCentroCostoChange}
                    OnInputValorReferencia={OnInputValorReferencia}
                    centrosCosto={centrosCosto}
                    renglonesAgregadosManualmente={renglonesAgregadosManualmente}
                    estaDesplegado={estaDesplegado}
                    renglonAgregadoManualmente={registro && !!registro.RenglonAgregadoManualmente}
                    renglonManual={registro && registro.TipoRenglon == 2}
                    tienePermisoModificacion={tienePermisoModificacion}
                />
            </div>
        );        
    }
}

export default RegistroRenglonAsiento;
